import api from "@/services/api/api-reserved"

export default class ReservedService {
  async list(query) {
    try {
      let res = await api.list(query)
      if(!res.results) throw new Error('Something wrong and Reserved exams not loading. Please, reload page or try later.')
      let data = {
        results: res.results,
        pagination: {
          count: res.count,
          next: res.next,
          previous: res.previous
        }
      }
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  }
}